import Header from '../components/header/header'
import CTASection from '../components/cta-section/cta-section'
import Footer from '../components/footer/footer'
import { HeadingWithDescription } from '../components/common/heading-with-description'
import { WhatIsAiAura } from '../components/what-is-aiaura/what-is-aiaura'
import { HightIMpactFeatures } from '../components/high-impact-features/high-impact-features'
import Carousel from '../components/carousel-component/carousel-component'

export const AboutUs = () => {
  return (
    <div className='bg-[#000f2c]'>
      <Header />
      <HeadingWithDescription containerClass="py-10" headingOne="AIAura" headingTow="Core" description="AIAURA Core is your plug-and-play engine for internal mobility, referrals, and recruiter collaboration—fully branded, instantly integrated."/>
      <WhatIsAiAura />
      <Carousel />
      <HightIMpactFeatures/>
      <CTASection />
      <Footer />
    </div>
  )
}
